import {
    // FILE_UPLOAD,
    CREATE_INACTIVESHARABLELINKS,
    RETRIEVE_INACTIVESHARABLELINKS,
    UPDATE_INACTIVESHARABLELINKS,
    DELETE_INACTIVESHARABLELINKS,
} from "./type";
import InactiveSharableLinks from "../service/InactiveSharableLinks";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await InactiveSharableLinks.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await InactiveSharableLinks.create(data);
        dispatch({
            type: CREATE_INACTIVESHARABLELINKS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await InactiveSharableLinks.fetchList(data);
        dispatch({
            type: RETRIEVE_INACTIVESHARABLELINKS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await InactiveSharableLinks.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_INACTIVESHARABLELINKS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await InactiveSharableLinks.update(data);
        dispatch({
            type: UPDATE_INACTIVESHARABLELINKS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await InactiveSharableLinks.changeStatus(data);
//         dispatch({
//             type: UPDATE_INACTIVESHARABLELINKS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await InactiveSharableLinks.trash(data);
        dispatch({
            type: DELETE_INACTIVESHARABLELINKS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};